import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { MinDTO } from 'src/app/models/min-dto';
import { SeaPort } from 'src/app/models/sea/sea-port';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class SeaportVectorService extends BaseService<any>{
    constructor(public httpClient: HttpClient, public translation: TranslateService) {
        super(
            'seaportVector',
            httpClient);
    }

    autocomplete = this.searchPortVector;

searchPortVector(q): Observable<any[]> {
    let uri = new URL(environment.baseUrl + `/ports/search`).updateQueryParam({q});

    return this.httpClient.get<any[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
        .pipe(
            map((res: any[]) => {
               
                // Gelen her bir objeyi component'in anladığı dile çeviriyoruz
                return res.map(item => ({
                    ...item,
                    id: item.seaportId,       // Component'in aradığı 'id'
                    name:  this.translation.currentLang == 'en' ? item.displayNameEn : item.displayNameTr  // Component'in aradığı 'name' dile göre
                }));
            }),
            catchError(this.handleError)
        )
}


}
